import React from 'react';
import {Video, Formatted} from 'components';
import {config} from 'helpers';

export function Strengths() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.identity.strengths} />
      <div className="medium-spacing">
        <p>Each of us is born with a unique combination of characteristics and special abilities.</p>
        <p>We all have specific talents and gifts, and are drawn to certain things in life. When you utilize your strengths and do what you are naturally good at, life feel more effortless and enjoyable. When you experience success and enjoy what you're doing, you send a positive energy into the world, which in turns comes back to support you. Recognizing your unique set of strengths and talents is an integral step in discovering who you truly are. Get ready to shine!</p>
      </div>
    </Formatted>
  );
}
